import React, { useEffect } from 'react'
import Logo from '../components/layout/assets/Logo principal.png'
import { 
  FaEnvelope, 
  FaUsers, 
  FaChartLine
} from 'react-icons/fa'
import './Home2.css'

// eslint-disable-next-line
export default function (props) {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'auto',
    })
  }, [])

  return (
    <div className="welcome-container">
      <div className="welcome-content">
        <div className="welcome-card">
          <img
            className="welcome-logo-small"
            src={Logo}
            alt="Develemos Logo"
          />
          <h1 className="welcome-title">
            ¡Bienvenido!
          </h1>
          
          <div className="welcome-message">
            <p>
              🎉 <strong>¡Felicitaciones!</strong> Te has registrado correctamente en nuestra plataforma.
            </p>
            <p className="verify-email-highlight">
              📧 <strong>Te enviamos un correo electrónico para que verifiques tu cuenta</strong> y comiences a explorar todas las funcionalidades disponibles.
            </p>
            <p>
              🚀 Ya estás listo para crear sesiones increíbles y gestionar tu contenido de manera profesional.
            </p>
          </div>

          <div className="welcome-features">
            <div className="feature-item">
              <div className="feature-icon">
                <FaUsers />
              </div>
              <h3 className="feature-title">Gestión de Usuarios</h3>
              <p className="feature-description">
                Administrá usuarios, permisos y roles de manera eficiente
              </p>
            </div>
            
            <div className="feature-item">
              <div className="feature-icon">
                <FaEnvelope />
              </div>
              <h3 className="feature-title">Sesiones Interactivas</h3>
              <p className="feature-description">
                Creá y gestioná sesiones dinámicas con contenido multimedia
              </p>
            </div>
            
            <div className="feature-item">
              <div className="feature-icon">
                <FaChartLine />
              </div>
              <h3 className="feature-title">Reportes y Análisis</h3>
              <p className="feature-description">
                Obtené insights detallados sobre el rendimiento de tus sesiones
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
